const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Auto Switch Transporter Non Placement',
  description: 'Auto re-indent to another transporter can be set for various options. To enable it must be set as true.',
  sortOrder: 1,
  name: 'auto_switch_transporter_on_non_placement',
  documentKey: 'auto_switch_transporter_on_non_placement',
  values: {
    is_enabled_for_primary: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'is_enabled_for_primary',
      documentKey: 'is_enabled_for_primary',
    },
    is_enabled_for_secondary: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'is_enabled_for_secondary',
      documentKey: 'is_enabled_for_secondary',
    },
    is_enabled_for_vendor: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'is_enabled_for_vendor',
      documentKey: 'is_enabled_for_vendor',
    },
    is_enabled_for_return: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'is_enabled_for_return Date',
      documentKey: 'is_enabled_for_return',
    },
    is_enabled_for_ftl: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'is_enabled_for_ftl',
      documentKey: 'is_enabled_for_ftl',
    },
    is_enabled_for_ptl: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'is_enabled_for_ptl',
      documentKey: 'is_enabled_for_ptl',
    },
    auto_switch_on_sla_breach: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'auto_switch_on_sla_breach',
      documentKey: 'auto_switch_on_sla_breach',
    },
  },
};
